module.exports = __webpack_public_path__ + "static/media/Air Asia_4_Calendar.646668af.jpg";